import { SEARCH_DATE_RANGE, CLEAR_SEARCH_DATES } from '../actions';

const initialState = {
	startDate: '',
	endDate: ''
};
export default (state = initialState, action) => {
	switch (action.type) {
		case SEARCH_DATE_RANGE:
			return {
				startDate: action.payload.startDate,
				endDate: action.payload.endDate
			};
		case CLEAR_SEARCH_DATES:
			return {
				startDate: action.payload.startDate,
				endDate: action.payload.endDate
			};
	}
	return state;
}